function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledSwitch, StyledSwitchCheckedIcon, StyledSwitchUnCheckedIcon, StyledSwitchInput, StyledSwitchKnob, StyledSwitchLabel, StyledSwitchTrack } from './Switch.styled';
function Switch(_ref) {
  var checked = _ref.checked,
    checkedIcon = _ref.checkedIcon,
    color = _ref.color,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    elevate = _ref.elevate,
    label = _ref.label,
    labelPlacement = _ref.labelPlacement,
    onChange = _ref.onChange,
    name = _ref.name,
    required = _ref.required,
    size = _ref.size,
    uncheckedIcon = _ref.uncheckedIcon,
    value = _ref.value;
  var inputProps = _extends({
    disabled: disabled
  }, checked !== undefined && {
    checked: checked
  }, defaultChecked !== undefined && {
    defaultChecked: defaultChecked
  }, onChange !== undefined && {
    onChange: onChange
  }, required !== undefined && {
    required: required
  }, value !== undefined && {
    value: value
  });
  return /*#__PURE__*/React.createElement(StyledSwitch, {
    disabled: disabled,
    labelPlacement: labelPlacement,
    size: size
  }, /*#__PURE__*/React.createElement(StyledSwitchInput, _extends({
    color: color,
    name: name,
    size: size
  }, inputProps)), label && /*#__PURE__*/React.createElement(StyledSwitchLabel, {
    placement: labelPlacement,
    required: required
  }, label), /*#__PURE__*/React.createElement(StyledSwitchTrack, {
    elevate: elevate,
    size: size
  }, (checkedIcon || uncheckedIcon) && /*#__PURE__*/React.createElement(StyledSwitchCheckedIcon, {
    color: color
  }, checkedIcon), /*#__PURE__*/React.createElement(StyledSwitchKnob, {
    size: size
  }), (checkedIcon || uncheckedIcon) && /*#__PURE__*/React.createElement(StyledSwitchUnCheckedIcon, {
    color: color
  }, uncheckedIcon)));
}
Switch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the component will be checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   * If `true` and uncontrolled, the component will be checked.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, will add box shadow
   */
  elevate: PropTypes.bool,
  /**
   * HTML label for the component.
   */
  label: PropTypes.node,
  /**
   * Position of the label.
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string.isRequired,
  /**
   * If `true`, will add box shadow
   */
  required: PropTypes.bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),
  /**
   * The icon to display when the component is unchecked.
   */
  uncheckedIcon: PropTypes.node,
  /**
   * The value of the component. The DOM API casts this to a string. The browser uses "on" as the default value.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
Switch.defaultProps = {
  checked: undefined,
  checkedIcon: undefined,
  color: 'primary',
  defaultChecked: undefined,
  disabled: false,
  elevate: false,
  label: undefined,
  labelPlacement: 'top',
  onChange: undefined,
  required: undefined,
  size: 'medium',
  uncheckedIcon: undefined,
  value: undefined
};
export default Switch;